module.exports = __webpack_public_path__ + "bb4821583755b9410c9250a20c8d5964.png";